/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import Loader from "../../Components/Loader";
import { productActionCreators } from "../../services/Actions";
import ProductModal from "../Modal/AddProductModal";
// Relocated to the Inventory module: renders inside the Inventory layout.
import RenderHirePurchasePage from "../../InventoryModel/RenderInventoryPage";
import { RiDeleteBin2Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import moment from "moment";
import { GetUserProfile } from "../../services/Actions/authActions";
import PromptModal from "../../AdminModel/Components/PromptModal";

function Vendors() {
  const dispatch = useDispatch();
  const {
    ResetProductResponse,
    DeleteSupplier,
    AddSupplier,
    GetSuppliers,
    EditSupplier,
  } = bindActionCreators(productActionCreators, dispatch);

  const product = useSelector((state) => state?.product);
  const { suppliers, response, isLoading } = product;

  const [openPromptModal, setPromptOpenModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openEditSupplierModal, setOpenEditSupplieModal] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);

  const [supplierFormData, setSupplierFormData] = useState({
    name: "",
    location: "",
    address: "",
    products_supplied: "",
    website_url: "",
    email: "",
    phone_1: "",
    phone_2: "",
    description: "",
  });

  const [supplierEditFormData, setSupplierEditFormData] = useState({
    name: "",
    location: "",
    address: "",
    products_supplied: "",
    website_url: "",
    email: "",
    phone_1: "",
    phone_2: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSupplierFormData({ ...supplierFormData, [name]: value });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setSupplierEditFormData({ ...supplierEditFormData, [name]: value });
  };

  const handleSubmitSupplier = (e) => {
    e.preventDefault();
    AddSupplier(supplierFormData);
  };

  const handleSubmitEditSupplier = (e) => {
    e.preventDefault();
    EditSupplier(selectedSupplier?._id, supplierEditFormData);
  };

  useEffect(() => {
    GetSuppliers();
    dispatch(GetUserProfile());
  }, []);

  useEffect(() => {
    if (selectedSupplier) {
      setSupplierEditFormData({
        name: selectedSupplier?.name || "",
        address: selectedSupplier?.address || "",
        location: selectedSupplier?.location || "",
        email: selectedSupplier?.email || "",
        phone_1: selectedSupplier?.phone_1 || "",
        phone_2: selectedSupplier?.phone_2 || "",
        description: selectedSupplier?.description || "",
        products_supplied: selectedSupplier?.products_supplied || "",
        website_url: selectedSupplier?.website_url || "",
      });
    }
  }, [selectedSupplier]);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setOpenModal(false);
      setOpenEditSupplieModal(false);
      setSupplierFormData({
        name: "",
        location: "",
        address: "",
        products_supplied: "",
        website_url: "",
        email: "",
        phone_1: "",
        phone_2: "",
        description: "",
      });

      setTimeout(() => {
        ResetProductResponse();
        GetSuppliers();
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => {
        ResetProductResponse();
      }, 1500);
    }
  }, [response]);

  return (
    <RenderHirePurchasePage>
      {isLoading && <Loader />}

      <div className="flex justify-between items-center mt-4">
        <h2 className="text-2xl font-bold text-gray-800">Vendors Management</h2>
        <button
          type="button"
          className="text-white bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 shadow-lg font-medium rounded-lg text-sm px-5 py-2.5 transition-all"
          onClick={() => setOpenModal(true)}
        >
          + Add New Vendor
        </button>
      </div>

      <section className="bg-white mt-6 shadow-sm rounded-xl border border-gray-100">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                  Vendor Info
                </th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                  Location
                </th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                  Products Supplied
                </th>
                <th className="px-6 py-4 text-left text-xs font-bold text-gray-500 uppercase tracking-wider">
                  Added On
                </th>
                <th className="px-6 py-4 text-center text-xs font-bold text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-100">
              {suppliers?.map((supplier, index) => (
                <tr
                  key={supplier._id || index}
                  className="hover:bg-gray-50 transition-colors"
                >
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="text-sm font-semibold text-gray-900">
                      {supplier?.name}
                    </div>
                    <div className="text-xs text-gray-500">
                      {supplier?.email || "No email provided"}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                    {supplier?.location || "N/A"}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600 max-w-xs truncate">
                    {supplier?.products_supplied}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {moment(supplier?.created_at).format("MMM DD, YYYY")}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                    <div className="flex justify-center space-x-4">
                      <button
                        onClick={() => {
                          setSelectedSupplier(supplier);
                          setOpenEditSupplieModal(true);
                        }}
                        className="text-blue-600 hover:text-blue-900 dark:hover:text-blue-700 p-2 rounded-full transition-colors"
                        title="Edit Vendor"
                      >
                        <FiEdit size={18} />
                      </button>
                      <button
                        onClick={() => {
                          setSelectedSupplier(supplier);
                          setPromptOpenModal(true);
                        }}
                        className="text-red-600 hover:text-red-900 dark:hover:text-red-700 p-2 rounded-full transition-colors"
                        title="Delete Vendor"
                      >
                        <RiDeleteBin2Line size={18} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* Add Modal */}
      {openModal && (
        <ProductModal
          closeModal={setOpenModal}
          width="60%"
          title={"Register New Vendor"}
        >
          <form onSubmit={handleSubmitSupplier} className="p-4">
            <div className="grid gap-4 mb-4 md:grid-cols-2">
              <div>
                <label className="block mb-2 text-sm font-bold text-gray-700">
                  Vendor Name *
                </label>
                <input
                  type="text"
                  name="name"
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:ring-blue-500 focus:border-blue-500"
                  placeholder="e.g. Global Tech Solutions"
                  required
                />
              </div>
              <div>
                <label className="block mb-2 text-sm font-bold text-gray-700">
                  Main Products
                </label>
                <input
                  type="text"
                  name="products_supplied"
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                  placeholder="e.g. Hardware, Office Supplies"
                />
              </div>
              <div>
                <label className="block mb-2 text-sm font-bold text-gray-700">
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                  placeholder="contact@vendor.com"
                />
              </div>
              <div>
                <label className="block mb-2 text-sm font-bold text-gray-700">
                  Website
                </label>
                <input
                  type="text"
                  name="website_url"
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                  placeholder="https://www.vendor.com"
                />
              </div>
              <div>
                <label className="block mb-2 text-sm font-bold text-gray-700">
                  Phone (Primary)
                </label>
                <input
                  type="text"
                  name="phone_1"
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                />
              </div>
              <div>
                <label className="block mb-2 text-sm font-bold text-gray-700">
                  Location/City
                </label>
                <input
                  type="text"
                  name="location"
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                  placeholder="e.g. Lagos, Nigeria"
                />
              </div>
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-sm font-bold text-gray-700">
                Company Description
              </label>
              <textarea
                name="description"
                rows="3"
                onChange={handleChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                placeholder="Brief details about the vendor..."
              ></textarea>
            </div>
            <div className="flex items-center justify-end space-x-3 pt-4 border-t">
              <button
                type="button"
                onClick={() => setOpenModal(false)}
                className="px-5 py-2.5 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isLoading}
                className="px-5 py-2.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 shadow-md"
              >
                {isLoading ? "Processing..." : "Save Vendor"}
              </button>
            </div>
          </form>
        </ProductModal>
      )}

      {/* Edit Modal - Similar Layout to Add Modal for Consistency */}
      {openEditSupplierModal && (
        <ProductModal
          closeModal={setOpenEditSupplieModal}
          width="60%"
          title={"Update Vendor Details"}
        >
          <form onSubmit={handleSubmitEditSupplier} className="p-4">
            {/* Fields populated with supplierEditFormData.value */}
            <div className="grid gap-4 mb-4 md:grid-cols-2">
              <div>
                <label className="block mb-2 text-sm font-bold text-gray-700">
                  Vendor Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={supplierEditFormData.name}
                  onChange={handleEditChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                />
              </div>
              <div>
                <label className="block mb-2 text-sm font-bold text-gray-700">
                  Products Supplied
                </label>
                <input
                  type="text"
                  name="products_supplied"
                  value={supplierEditFormData.products_supplied}
                  onChange={handleEditChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                />
              </div>
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-sm font-bold text-gray-700">
                Company Description
              </label>
              <textarea
                name="description"
                rows="3"
                value={supplierEditFormData.description}
                onChange={handleEditChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
              ></textarea>
            </div>
            <div className="flex items-center justify-end space-x-3 pt-4 border-t">
              <button
                type="button"
                onClick={() => setOpenEditSupplieModal(false)}
                className="px-5 py-2.5 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isLoading}
                className="px-5 py-2.5 text-sm font-medium text-white bg-green-600 rounded-lg hover:bg-green-700"
              >
                {isLoading ? "Updating..." : "Apply Changes"}
              </button>
            </div>
          </form>
        </ProductModal>
      )}

      {/* Delete Prompt remains functional as per original logic */}
      {openPromptModal && (
        <PromptModal
          width={"30%"}
          title={"Confirm Deletion"}
          closeModal={setPromptOpenModal}
        >
          <div className="p-6 text-center">
            <RiDeleteBin2Line size={48} className="mx-auto text-red-500 mb-4" />
            <h3 className="mb-5 text-lg font-medium text-gray-700">
              Remove <span className="font-bold">{selectedSupplier?.name}</span>{" "}
              from the system?
            </h3>
            <div className="flex justify-center space-x-4">
              <button
                onClick={() => {
                  DeleteSupplier(selectedSupplier?._id);
                  setPromptOpenModal(false);
                }}
                className="text-white bg-red-600 hover:bg-red-700 font-medium rounded-lg text-sm px-6 py-2.5"
              >
                Confirm Delete
              </button>
              <button
                onClick={() => setPromptOpenModal(false)}
                className="text-gray-600 bg-gray-100 border border-gray-200 rounded-lg text-sm px-6 py-2.5"
              >
                Cancel
              </button>
            </div>
          </div>
        </PromptModal>
      )}

      <ToastContainer autoClose={3000} />
    </RenderHirePurchasePage>
  );
}

export default Vendors;
